
import { CircularProgress, Autocomplete, TextField } from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

const AutocompleteSingleSelect = ({
  id,
  value,
  setValue,
  noOptionsText,
  placeholder,
  isLoading,
  onInputChange,
  disabled,
  options = [],
}) => {
  const values = options.map((o) => o);

  return (
    <Autocomplete
      id={id}
      fullWidth
      disabled={isLoading || disabled}
      popupIcon={<KeyboardArrowDownRoundedIcon sx={{ fontSize: 12, fill: "#A0B5BE" }} />}
      
      sx={{
        "& .MuiAutocomplete-option[aria-selected='true']": {
          backgroundColor: "red !important", // Selected option background color
          color: "#fff !important", // Selected option text color
        },
        "& .MuiOutlinedInput-root": {
          flexWrap: "nowrap",
          position: "relative",
          py: 0,
          borderRadius: "0.625rem",
          fontSize:'small !important',
          // border: "none",
          paddingRight: "1px !important",
          "&> .MuiFormControl-root": {
            border: 0,
            "&+ .MuiCircularProgress-root": {
              position: "absolute",
              top: "11.5px",
              right: "35px",
            },
          },
         
        },
        "&> .MuiFormControl-root .MuiInputBase-root": {
          padding: 0,
        },
        "&> .MuiFormControl-root .MuiInputBase-root.Mui-focused": {
          border: "none !important",
        }
      }}
      noOptionsText={noOptionsText}
      value={value || null}
      onChange={(_, newValue) => {
        setValue(newValue ? newValue : "");
      }}
      options={values}
      
      getOptionLabel={(option) => {

        if (option && typeof option === 'object' && 'name' in option) {
          return option.name;
        }
      
        // If option is not an object or doesn't have a name, convert to a string
        return String(option);
      }}
      isOptionEqualToValue={(option, value) => option.value === value.value}

      onInputChange={onInputChange}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <CircularProgress color="info" size={18} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default AutocompleteSingleSelect;
